export default __webpack_public_path__ + "static/media/landscape17.23c1b570.jpeg";